import { useReveal } from "../hooks/useReveal";

export default function Merch() {
  const { ref, visible } = useReveal();

  return (
    <section
      id="merch"
      data-testid="merch-section"
      ref={ref}
      className={`relative bg-white py-28 md:py-36 px-6 md:px-12 lg:px-20 reveal ${
        visible ? "in-view" : ""
      }`}
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <div className="overline mb-5">store · merch</div>
            <h2 className="font-serif-display text-5xl md:text-7xl text-[#0A0A0A] leading-[0.95] tracking-tight">
              The <span className="italic">collection.</span>
            </h2>
          </div>
          <p className="text-base md:text-lg text-[#595959] leading-relaxed max-w-md">
            A small, considered drop. Designed for slow afternoons and long drives.
          </p>
        </div>

        <div className="border-t border-b border-[#E6EAEF] py-24 md:py-32 text-center">
          <div className="overline mb-6">opening soon</div>
          <h3
            data-testid="merch-headline"
            className="font-serif-display text-3xl md:text-5xl italic text-[#0A0A0A] leading-tight max-w-2xl mx-auto"
          >
            The store opens with the release of <span className="not-italic">SE1.</span>
          </h3>
          <div className="mt-10 flex items-center justify-center gap-4">
            <div className="h-px w-12 bg-[#E6EAEF]" />
            <span className="font-mono-meta text-[10px] tracking-[0.3em] uppercase text-[#8C8C8C]">
              subscribe below to be notified first
            </span>
            <div className="h-px w-12 bg-[#E6EAEF]" />
          </div>
        </div>
      </div>
    </section>
  );
}
